// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"_17ZCw","spinCarDesktop":"_52OnX","imageWrapperOverFlow":"mssJD","carImage":"_3v40K","pinchText":"x8jRL","showcaseWrap":"_3cRz0"};